export default "__VITE_ASSET__KyyWQwoBf4YRI66TsiB0GQ__"